import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from 'nprogress'
import routes from './routes'
import { APP_TITLE, APP_HOMEPAGE } from '../_helpers/config'
import DataService from '../_helpers/data.service'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  linkExactActiveClass: 'active',
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})

NProgress.configure({ showSpinner: true })

router.beforeResolve((to, from, next) => {
  if (to.name === from.name) {
    window.location.reload()
    return
  }
  if (to.name) {
    NProgress.start()
    if (to.name === APP_HOMEPAGE) {
      document.title = APP_TITLE
    } else {
      const pageTitle = router.app.$options.i18n.t(`title.${to.name}`)
      document.title = `${pageTitle} | ${APP_TITLE}`
    }
  }
  const userLang = DataService.get('user_lang')
  if (userLang) {
    router.app.$options.i18n.locale = userLang
  }
  next()
})

router.afterEach(() => {
  NProgress.done()
})

export default router
